import React, { Component } from 'react'
import {
  Container,
  Grid,
  Header,
  Image
} from 'semantic-ui-react'
import {connect} from 'react-redux';

import {
    submitRequestAccountRecovery
} from '../../actions';
import FormsRecoverAccount from '../../component/forms/recover_account';

class RecoverAccountPage extends Component {
    componentDidMount() {
        if (this.props.userData) {
          this.props.history.push('/app');
        }
      }
    render() {
        return (
            <Container style={{ paddingTop: '2.5em' }}>

                <Image src="/groupcare_logo_hor.jpg" size="medium"/>

                <Header as='h2' block>
                    Recover Account
                </Header>

                <Grid centered columns={1}>
                    <Grid.Column>
                        <FormsRecoverAccount
                            submitRequestAccountRecovery={this.props.submitRequestAccountRecovery}
                        />
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return { userData: state.user.user };
  }

export default connect(mapStateToProps, { submitRequestAccountRecovery })(RecoverAccountPage);
